import { CSSProperties } from 'react';

export const getDefaultFallbackComponentStyle = (): CSSProperties => ({
  boxShadow: 'none',
});

export default {
  getDefaultFallbackComponentStyle,
};
